import { ReactComponent as PolicyIconSVG } from "./c-policy.svg";
import { SvgIcon } from '@mui/material';

export default function IconCPolicy(props) {
  return <SvgIcon {...props} component={PolicyIconSVG} viewBox="0 0 18 18" />;
}